module.exports = __webpack_public_path__ + "img/486.a8a653d0.png";